import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const VoidSummaryReport: React.FC = () => (
  <ReportPageShell
    reportType="void-summary"
    title="Void Summary"
    subtitle="POS void events grouped by source (whole-transaction vs line) and user. event_count is the number of events, not the quantity voided."
    maxRangeDays={366}
    bullets={[
      'Source (Transaction / Line)',
      'User Login',
      'User Name',
      'Event Count',
      'Total Amount',
    ]}
  />
);

export default VoidSummaryReport;
